<template>
  <div class="container">
    <h3 class="title">Recursos Financieros</h3>

    <div v-if="state">
      <section v-if="permiso">
        <div class="fnc-buttons container">
          <Help />
        </div>
      </section>
      <section>
        <section>
          <div class="titulo-c3">
            <h6 class="title">
              a) Resultados de la Gestión Financiera (Proporcionado por DIPRES)
            </h6>
          </div>
          <Resultados :state="state" />
        </section>

        <section>
          <div class="titulo-c3">
            <h6 class="title">
              <br />
              b) Comportamiento Presupuestario año {{ anio }} (Proporcionado por
              DIPRES)
            </h6>
          </div>
        </section>
        <hr />
        <Formacion />
        <hr />

        <BodyView :permiso="permiso" />
      </section>
    </div>

    <div v-else>
      <AlertError />
    </div>
  </div>
</template>

<script>
// import Upload from "./Upload.vue";
import BodyView from "./permission/BodyView.vue";
import Help from "../../../components/button/escritorio/Help.vue";
import { mapState } from "vuex";
import Resultados from "./permission/Resultados/Resultados.vue";
import Formacion from "./permission/InfomaciónProcesada/Informacion.vue";
import AlertError from "../../../components/error/AlertError.vue";

export default {
  components: {
    // Upload,
    BodyView,
    Help,
    Resultados,
    Formacion,
    AlertError
  },
  data() {
    return {
      permiso: false,
      datos: false,
      listData: [],
      dataTable: null,
      state: true,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.permiso = true;
      }
    },
  },

  mounted() {
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.fnc-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  text-align: center;
  margin-bottom: 20px;
}

.btn-humanos {
  margin-bottom: 20px;
}

.bx-download {
  font-size: 25px;
  margin-right: 10px;
}

.span-btn-text {
  font-size: 18px;
}

.bx-upload {
  font-size: 25px;
  margin-right: 10px;
}
.mt-3 {
  background: #4f52ff !important;
  color: #fff !important;
  border: none;
  margin-left: 10px;
  margin-top: -20px;
}
</style>
